const dtGenerator = require('../../../../../components/dt/dt-generator')
const dtHandler = require('../../../../../components/dt/dt-handler')
const dtSearch = require('../../../../../components/dt/dt-search')
const clientActivityMenu = require('./clientActivity-menu')
const { organizeRow } = require('./clientActivity-dt-handler')
const { tableDetail } = require('./clientActivity-dt-handler')
const clientActivityFetch = require('./clientActivity-fetch')
const settings = require('../../../../../js-handler/settings')

/****************ELEMENTS*****************/
var htmlDt = {}
var HTMLwasSelected = false
var iframe;


function HTMLselect() {

      dtHandler.HTMLselect('clientActivity-dt', htmlDt, organizeRow, tableDetail)
      iframe = document.getElementById("reportIframe") ?? null;
      HTMLwasSelected = true
}/**/
/****************ELEMENTS*****************/

export function start(detail) {  //console.log('clientActivity-dt 5>', detail)

      if (!HTMLwasSelected) { HTMLselect() }

      obj[detail.act].start(detail)

}/**/

const obj = {

      //From fullcont connection    
      addRow: { start: (detail) => { dtGenerator.addRow(detail, htmlDt) } },
      tableOptions: { start: (detail) => { clientActivityMenu.start(detail, htmlDt, 'htmlFc') } },
      trMenu: { start: (detail) => { clientActivityMenu.start(detail, htmlDt, 'htmlFc') } },
      updateRow: { start: (detail) => { dtGenerator.updateRow(detail, htmlDt) } },
      //data table
      filter: { start: (detail) => { dtSearch.filter(detail, htmlDt) } },
      filterShowHide: { start: (detail) => { dtSearch.filterShowHide(detail, htmlDt) } },
      loadMore: { start: (detail) => { dtSearch.loadMore(detail, htmlDt) } },
      searching: { start: (detail) => { dtSearch.searching(detail, htmlDt) } },
      select: { start: (detail) => { select(detail, htmlDt) } },
      th: { start: (detail) => { dtSearch.th(detail, htmlDt) } },

}/**/

function select(detail, htmlDt) {
      dtSearch.select(detail, htmlDt, true);
      showCompanyName()

      const fetchDetail = {
            dest: "provider",
            elem: "report",
            reportType: "accountPayableAll",
      };

      clientActivityFetch.fetchAll(fetchDetail, (data) => {
            if (!Array.isArray(data) || data.length === 0) {
                  return;
            }
      });
}

function showCompanyName() {
      const titleAppBar = document.querySelector("#appbar").querySelector("h1");
      titleAppBar.textContent = `BeeStock - ${settings.getData().name}`;
}